/**
 * formSubmit
 * Search Form submit handlers
 */
let formSubmit = (event) => {
	let target = event.target;
	if (target) {
		let input = target.querySelector('input');
		let value = input.value;
		if (!value) {
			event.preventDefault();
			input.focus();
		}
	}
};

let searchForms = document.querySelectorAll('form.oda-search');
searchForms.forEach(function (form) {
	form.addEventListener('submit', function (event) {
		formSubmit(event);
	});
});

/**
 * mobileSearch
 * Functions related to the mobile search only
 */
let mobileSearch = {
	container: document.querySelector('.mobile--search-drop'),
	toggle: document.querySelector('button.search-toggle'),
	submitInput: document.querySelector('.mobile--search-drop input'),
	submitBtn: document.querySelector(
		'.mobile--search-drop button[type=submit]'
	),

	clickHandler: () => {
		console.log('test');
		if (mobileSearch.container.classList.contains('active')) {
			mobileSearch.close();
		} else {
			mobileSearch.open();
		}
	},
	open: () => {
		mobileSearch.container.classList.add('active');
		mobileSearch.container.setAttribute('aria-hidden', true);
		mobileSearch.toggle.setAttribute('aria-expanded', true);
		mobileSearch.toggle.classList.add('active');
		setTimeout(function () {
			mobileSearch.container.querySelector('input').focus();
			document.addEventListener('keydown', mobileSearch.escFunction);
			document.addEventListener('click', mobileSearch.clickOutside);
		}, 175);
	},
	close: () => {
		mobileSearch.container.classList.remove('active');
		mobileSearch.container.setAttribute('aria-hidden', false);
		mobileSearch.toggle.setAttribute('aria-expanded', false);
		mobileSearch.toggle.classList.remove('active');
		document.removeEventListener('keydown', mobileSearch.escFunction);
		document.removeEventListener('click', mobileSearch.clickOutside);
	},
	escFunction: (event) => {
		if (event.keyCode === 27 || event.key === 'Escape') {
			mobileSearch.close();
		}
	},
	clickOutside: (event) => {
		if (event.target.closest('.mobile--search-drop')) {
			return;
		}
		mobileSearch.close();
	},
	tabOut: function (e) {
		let keyCode = e.keyCode || e.which;
		// Tab fwd only
		if (!e.shiftKey && keyCode == 9) {
			mobileSearch.close();
		}
	},
	tabBackwards: function (e) {
		let keyCode = e.keyCode || e.which;
		// Tab backwards only
		if (e.shiftKey && keyCode == 9) {
			mobileSearch.close();
		}
	},
};

// Set up event listeners
if (mobileSearch.toggle && mobileSearch.container) {
	mobileSearch.toggle.addEventListener('click', mobileSearch.clickHandler);

	if (mobileSearch.submitBtn) {
		mobileSearch.submitBtn.addEventListener('keydown', function (e) {
			mobileSearch.tabOut(e);
		});
		mobileSearch.submitInput.addEventListener('keydown', function (e) {
			mobileSearch.tabBackwards(e);
		});
	}
}
